import { LoadingButton } from "@mui/lab";
import { TextField, Stack, Card, CardActions, CardContent, CardHeader, Typography, IconButton, Tooltip } from "@mui/material";
import { Dispatch, SetStateAction, useContext, useState } from "react";
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import RefreshIcon from '@mui/icons-material/Refresh';
import { bhpButtonSx } from "../../styles/bhpStyles";
import { ResidentDto } from "./dtos/ResidentDto";
import VillageConsoleContext from "../../store/VillageConsoleContext";
import { Domains } from "../../data/Domains";


type SearchResidentProps = {

    isLoading: boolean;
    selectResident:  Dispatch< SetStateAction< ResidentDto | undefined > >;

};



const textFieldSx = {
    
    width: '250px'

};


export const SearchResident : React.FC< SearchResidentProps > = ( props : SearchResidentProps ) => {

    const { isLoading, selectResident } = props;
    
    const [ canSearch, setCanSearch ] = useState<boolean>( false );
    const [ employeeId, setEmployeeId ] = useState<string>( '' );
    const [ firstName, setFirstName ] = useState<string>( '' );
    const [ lastName, setLastName ] = useState<string>( '' );

    const { domain } = useContext( VillageConsoleContext );


    const handleEmployeeIdChange = ( event: React.ChangeEvent<HTMLInputElement> ) => {

        setEmployeeId( event.target.value.trim( ) );
        setFirstName( '' );        
        setLastName( '' );
        setCanSearch( event.target.value.trim( ).length > 2 ? true : false );

    };


    const handleEmployeeIdKeyPress = async ( event: React.KeyboardEvent<HTMLDivElement> ) => {

        if( !canSearch || event.key !== 'Enter' ) {
            
            return;

        }

        setResidentSearch( );

    };


    const handleFirstNameChange = ( event: React.ChangeEvent<HTMLInputElement> ) => {

        setEmployeeId( '' );
        setFirstName( event.target.value.trimStart( ) );
        setCanSearch( ( event.target.value.trim( ).length > 1 && lastName.length > 1 ) ? true : false );

    };


    const handleFirstNameKeyPress = async ( event: React.KeyboardEvent<HTMLDivElement> ) => {

        if( !canSearch || event.key !== 'Enter' ) {
            
            return;

        }

        setResidentSearch( );

    };


    const handleResetClick = ( ) => {

        setCanSearch( false );
        setEmployeeId( '' );
        setFirstName( '' );
        setLastName( '' );
        selectResident( undefined );

    };


    const handleSearchPersonClick = ( ) => {

        setResidentSearch( );

    }


    const handleLastNameChange = ( event: React.ChangeEvent<HTMLInputElement> ) => {

        setEmployeeId( '' );
        setLastName( event.target.value.trimStart( ) );
        setCanSearch( ( event.target.value.trim( ).length > 1 && firstName.length > 1 ) ? true : false );

    };


    const handleLastNameKeyPress = async ( event: React.KeyboardEvent<HTMLDivElement> ) => {

        if( !canSearch || event.key !== 'Enter' ) {
            
            return;

        }

        setResidentSearch( );

    };


    const setResidentSearch = ( ) => {

        const residentDto: ResidentDto = {
            
            domain: domain as Domains,
            employeeId,
            firstName: firstName.trim( ),
            lastName: lastName.trim( )

        };
        
        selectResident( residentDto );

    };

  
    return (

        <>
      
            <Card sx={{ alignSelf: 'center', boxShadow: 5, width: '815px' }}>

                <CardHeader 
                    sx={{ fontWeight: '600', fontSize: '20px', paddingTop: '5px', paddingBottom: '0' }}
                    title="Resident Search"
                    avatar={
                        <PersonSearchIcon />
                    }
                    action={
                        <Tooltip title="Reset">
                            <IconButton onClick={ handleResetClick }>
                                <RefreshIcon />
                            </IconButton>
                        </Tooltip>
                    }
                />

                <CardContent>
                    
                    <Stack direction="row" gap={0.5} display="flex" alignItems="center" >
                        
                        <TextField
                            sx={ textFieldSx } 
                            label="First Name" 
                            variant="outlined"
                            value={ firstName }
                            onChange={ handleFirstNameChange }
                            onKeyPress={ handleFirstNameKeyPress }
                            disabled={ isLoading }
                        />

                        <TextField 
                            sx={{ ...textFieldSx, marginLeft: '5px' }} 
                            label="Last Name" 
                            variant="outlined"
                            value={ lastName }
                            onChange={ handleLastNameChange }
                            onKeyPress={ handleLastNameKeyPress }
                            disabled={ isLoading } 
                        />

                        <Typography>
                            or
                        </Typography>
                        
                        <TextField 
                            sx={ textFieldSx } 
                            label="Employee ID" 
                            variant="outlined"
                            value={ employeeId}
                            onChange={ handleEmployeeIdChange }
                            onKeyPress={ handleEmployeeIdKeyPress }
                            disabled={ isLoading }
                        />

                    </Stack>

                </CardContent>

                <CardActions
                    sx={{
                        display: "flex",
                        justifyContent: "flex-end"
                    }}
                >

                    <LoadingButton
                        sx={{ ...bhpButtonSx, fontWeight: 'bold', height: '55px', marginBottom: '10px', marginRight:'10px', textTransform: 'none', width: '150px' }}
                        loadingPosition="start"
                        startIcon={<PersonSearchIcon />}
                        variant="contained"
                        disabled={ !canSearch || isLoading }
                        onClick={ handleSearchPersonClick }
                        loading={ isLoading }
                    >
                        Search
                    </LoadingButton>
                    
                </CardActions>    

            </Card>    

        </>

    );
  
};
